import inputTypes from '../operator-selector/supported-input-types';

function getDefaultValue() {

  return { label: '', key: '' };

}

function getSingleInputInitialValue(previousOperator, value) {

  if (previousOperator.supportedInputType === inputTypes.SINGLE) {

    return value;

  } else if (previousOperator.supportedInputType === inputTypes.MULTIPLE) {

    if (value.length > 0) {
      return value[0];
    }

    return getDefaultValue();

  } else if (previousOperator.supportedInputType === inputTypes.TEXT) {

    return getDefaultValue();

  } else if (previousOperator.supportedInputType === inputTypes.NUMBER) {

    return getDefaultValue();

  } else {

    return getDefaultValue();

  }

}

function getMultipleInputInitialValue(previousOperator, value) {

  if (previousOperator.supportedInputType === inputTypes.SINGLE) {

    if (value.label === '') {
      return [];
    }

    return [value];

  } else if (previousOperator.supportedInputType === inputTypes.MULTIPLE) {

    return value;

  } else if (previousOperator.supportedInputType === inputTypes.TEXT) {

    return [];

  } else if (previousOperator.supportedInputType === inputTypes.NUMBER) {

    return [];

  } else {

    return [];

  }

}

function getTextInputInitialValue(previousOperator, value) {

  if (previousOperator.supportedInputType === inputTypes.TEXT) {
    return value;
  }

  return getDefaultValue();

}

function getNumberInputInitialValue(previousOperator, value) {

  if (previousOperator.supportedInputType === inputTypes.NUMBER) {
    return value;
  }

  return getDefaultValue();

}

export function getInitialValue(newOperator, previousOperator, value) {

  if (newOperator.supportedInputType === inputTypes.SINGLE) {

    return getSingleInputInitialValue(previousOperator, value);

  } else if (newOperator.supportedInputType === inputTypes.MULTIPLE) {

    return getMultipleInputInitialValue(previousOperator, value);

  } else if (newOperator.supportedInputType === inputTypes.TEXT) {

    return getTextInputInitialValue(previousOperator, value);

  } else if (newOperator.supportedInputType === inputTypes.NUMBER) {

    return getNumberInputInitialValue(previousOperator, value);

  } else {

    return getDefaultValue();

  }

}